import { ComponentIds } from '@inter-ikea-core/core';
import { getComponentEntityMatcher } from './entity-matcher-utils';
const getOutlinedEntities = (sceneManagerOrCoreImpl) => getComponentEntityMatcher(ComponentIds.OUTLINED_COMPONENT_ID).filterSceneEntities(sceneManagerOrCoreImpl);
const removeOutlines = (sceneManagerOrCoreImpl) => {
    getOutlinedEntities(sceneManagerOrCoreImpl).forEach(entity => {
        entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
    });
};
/**
 * Unselects all selected entities
 * and removes lingering outlined components
 */
export const unselect = (sceneManagerOrCoreImpl, selectionService) => {
    selectionService.unselectAll();
    removeOutlines(sceneManagerOrCoreImpl);
};
/**
 * Selects an entity in the scene
 * @param {SceneManager | CoreImpl} sceneManagerOrCoreImpl - a scene manager from which to find planner product entities (or an implementation of core)
 * @param {RequiredSelectionServiceMethods} selectionService
 * @param entity entity to select
 */
export const select = (sceneManagerOrCoreImpl, selectionService, entity) => {
    if (entity) {
        selectionService.toggle(entity);
    }
    else {
        unselect(sceneManagerOrCoreImpl, selectionService);
    }
};
/**
 * Finds the selected entity
 * @param {SceneManager | CoreImpl} sceneManagerOrCoreImpl - a scene manager from which to find planner product entities (or an implementation of core)
 * @returns selected entity if there is exactly 1 or null if no entity is selected
 */
export const findSelectedEntity = (sceneManagerOrCoreImpl) => {
    const entities = getComponentEntityMatcher(ComponentIds.SELECTED_COMPONENT_ID).filterSceneEntities(sceneManagerOrCoreImpl);
    return entities.length === 1 ? entities[0] : null;
};
//# sourceMappingURL=selection-utils.js.map